module.exports = __webpack_public_path__ + "img/сollar_topline_length.27ec899b.png";